"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.petamiMerchantId = exports.defaultChainId = exports.testChainId = exports.ns = exports.companyName = void 0;
exports.companyName = "Gemunion Framework";
exports.ns = "gemunion";
exports.testChainId = 10001n;
exports.defaultChainId = process.env.NODE_ENV === "development" ? exports.testChainId : 181n;
exports.petamiMerchantId = process.env.NODE_ENV === "development" ? 3 : 5;
//# sourceMappingURL=company.js.map